// Pure visibility helpers for the topic-detail source-pill chips. Kept as a
// separate module so the conditional logic can be unit-tested without
// rendering React.

type EmailChipInput = {
  isClosed: boolean
  discarding: boolean
  blocking: boolean
  unsubscribing: boolean
  senderEmail: string
}

type EmailMutationStatus = 'discarding' | 'blocking' | 'unsubscribing' | null

type EmailChipVisibility = {
  showDiscard: boolean
  showBlock: boolean
  showUnsub: boolean
  mutationStatus: EmailMutationStatus
}

export function emailChipVisibility(s: EmailChipInput): EmailChipVisibility {
  // While any mutation is in flight the action buttons collapse and the
  // pill shows a single status line instead.
  const mutationStatus: EmailMutationStatus = s.discarding
    ? 'discarding'
    : s.blocking
      ? 'blocking'
      : s.unsubscribing
        ? 'unsubscribing'
        : null
  const idle = !s.isClosed && mutationStatus === null

  return {
    showDiscard: idle,
    showBlock: idle && !!s.senderEmail.trim(),
    showUnsub: idle,
    mutationStatus,
  }
}

export function architectureTopicActionBannerVisible(
  s: { sourceKind?: string | null; isClosed: boolean },
): boolean {
  return s.sourceKind === 'architecture_deepen' && !s.isClosed
}

const SOURCE_SPECIFIC_TOPIC_ACTION_KINDS = new Set([
  'architecture_deepen',
  'commitment_group',
  'commitment_followup',
  'commitment_review',
  'email_inbound',
  'todoist',
  'todoist_task',
  'x_bookmark',
])

export function commitmentActionStripVisible(sourceKind?: string | null): boolean {
  return sourceKind === 'commitment_review'
    || sourceKind === 'commitment_followup'
    || sourceKind === 'commitment_group'
}

export function genericTopicDoneActionBarVisible(s: {
  chatType?: string | null
  hasActiveTopic: boolean
  isClosed: boolean
  sourceResolved: boolean
  sourceKind?: string | null
}): boolean {
  if (s.chatType !== 'auto-spawn') return false
  if (!s.hasActiveTopic || s.isClosed || !s.sourceResolved) return false
  const sourceKind = (s.sourceKind || '').trim()
  return !sourceKind || !SOURCE_SPECIFIC_TOPIC_ACTION_KINDS.has(sourceKind)
}
